import logoUrl from '../assets/bill/invoice-logo.svg'
import signUrl from '../assets/bill/sign.png'

// Reference images backend se serve hote hain (QR isi URL ko encode karta hai).
const REF_BASE = 'https://maviinci-ai-bluepearl-e9750.web.app/api'

// QR remote API se (admin me qrcode npm dependency add karne ki zarurat nahi).
const qrUrl = (data, size = 150) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=0&data=${encodeURIComponent(data)}`

// ── Seller / Firm (Blue Pearl Industries — brand MAVIINCI) ───────────────────
const FIRM = {
  legalName: 'BLUE PEARL INDUSTRIES',
  brand: 'MAVIINCI',
  founder: 'Ibran Ahmad',
  founderMobile: '+91 88710 81395',
  coFounder: 'Mohammad Yaseen',
  coFounderMobile: '+91 88274 68142',
  address: 'Shanti Nagar, Bhilai 3, Bhilai',
  district: 'Dist - Durg, Chhattisgarh - 490021',
  website: 'www.maviinci.in',
  email: 'connect@bluepearlindustries.com',
  gstin: '22BMQPA3694H2ZY',
  state: 'Chhattisgarh',
  stateCode: '22',
}

const HSN_GARMENT = '6211'
const gstRateForPrice = price => (Number(price || 0) > 2500 ? 18 : 5)

const CAMPUS_STATE = {
  'IIT Bombay': 'Maharashtra', 'IIT Delhi': 'Delhi', 'IIT Madras': 'Tamil Nadu',
  'IIT Kanpur': 'Uttar Pradesh', 'IIT Kharagpur': 'West Bengal', 'IIT Roorkee': 'Uttarakhand',
  'IIT Guwahati': 'Assam', 'IIT Hyderabad': 'Telangana', 'IIT Gandhinagar': 'Gujarat',
  'IIT Ropar': 'Punjab', 'IIT Bhubaneswar': 'Odisha', 'IIT Jodhpur': 'Rajasthan',
  'IIT Patna': 'Bihar', 'IIT Indore': 'Madhya Pradesh', 'IIT Mandi': 'Himachal Pradesh',
  'IIT (BHU) Varanasi': 'Uttar Pradesh', 'IIT Palakkad': 'Kerala', 'IIT Tirupati': 'Andhra Pradesh',
  'IIT (ISM) Dhanbad': 'Jharkhand', 'IIT Bhilai': 'Chhattisgarh', 'IIT Goa': 'Goa',
  'IIT Jammu': 'Jammu & Kashmir', 'IIT Dharwad': 'Karnataka',
}

const GARMENT_SPEC = {
  coat:      { label: 'Coat',      length: 'coat_length',      fields: ['chest', 'stomach', 'hip', 'shoulder', 'sleeve', 'bicep', 'neck'] },
  pant:      { label: 'Pant',      length: 'trouser_length',   fields: ['waist', 'hip', 'crotch', 'thigh', 'bottom_opening'] },
  shirt:     { label: 'Shirt',     length: 'shirt_length',     fields: ['chest', 'stomach', 'hip', 'shoulder', 'sleeve', 'neck'] },
  vest_coat: { label: 'Vest Coat', length: 'vest_coat_length', fields: ['chest', 'stomach', 'hip', 'shoulder'] },
  tie:       { label: 'Tie',       length: null,               fields: [] },
}

const ALLOWANCE = {
  shirt: { shoulder: 1, sleeve: 1 },
  pant:  { thigh: 2.5 },
}

const FIELD_LABEL = {
  coat_length: 'Length', shirt_length: 'Length', trouser_length: 'Length', vest_coat_length: 'Length',
  chest: 'Chest', stomach: 'Stomach', hip: 'Hip', shoulder: 'Shoulder', sleeve: 'Sleeve', bicep: 'Bicep', neck: 'Neck',
  waist: 'Waist', crotch: 'Crotch', thigh: 'Thigh', bottom_opening: 'Bottom',
}

const PACKAGE_SPLIT = {
  'coat,pant,shirt,tie':           { coat: 30, pant: 30, shirt: 25, tie: 15 },
  'coat,pant,shirt,tie,vest_coat': { coat: 30, pant: 25, shirt: 20, vest_coat: 15, tie: 10 },
}
const TYPE_WEIGHT = { coat: 30, pant: 28, shirt: 24, vest_coat: 16, tie: 12 }

const safeNum = v => { const n = parseFloat(v); return Number.isFinite(n) ? n : 0 }
const fmtINR = v => `₹${Number(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
const abs = u => new URL(u, window.location.origin).href
const esc = s => String(s ?? '').replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]))

function fmtInch(v) {
  const n = safeNum(v)
  if (!n) return '—'
  const r = Math.round(n * 4) / 4
  return `${Number.isInteger(r) ? r : r.toFixed(2).replace(/0$/, '')}"`
}

function numberToWordsIN(num) {
  const value = Math.round(Number(num || 0))
  if (value === 0) return 'Zero Rupees Only'
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen']
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']
  const two = n => (n < 20 ? ones[n] : `${tens[Math.floor(n / 10)]}${n % 10 ? ' ' + ones[n % 10] : ''}`)
  const three = n => {
    const h = Math.floor(n / 100), rest = n % 100
    return `${h ? ones[h] + ' Hundred' + (rest ? ' ' : '') : ''}${rest ? two(rest) : ''}`
  }
  let n = value, words = ''
  const crore = Math.floor(n / 10000000); n %= 10000000
  const lakh = Math.floor(n / 100000); n %= 100000
  const thousand = Math.floor(n / 1000); n %= 1000
  if (crore) words += `${three(crore)} Crore `
  if (lakh) words += `${two(lakh)} Lakh `
  if (thousand) words += `${two(thousand)} Thousand `
  if (n) words += three(n)
  return `${words.trim()} Rupees Only`
}

// Kaarobaar ka niyam: kisi bhi ek item ki keemat 2500 se upar nahi jaati —
// isse har item 5% slab me rehta hai (2500 se upar 18% lagta hai). Bill ka
// total nahi badalta; sirf items ke beech baantne ka tareeqa badalta hai.
const ITEM_PRICE_CAP = 2500

/**
 * Har item ko 2500 par cap karo aur bacha hua amount un items me daalo jinme
 * abhi jagah hai. Sum hamesha total ke barabar rehta hai.
 * Agar total items×2500 se bhi zyada ho (jaise akela item 4000 ka) to cap
 * mumkin nahi — bachi raqam sabse bade item par chhod dete hain.
 */
function applyPriceCap(amounts, total) {
  const n = amounts.length
  if (!n) return amounts
  const out = amounts.map(v => Math.min(v, ITEM_PRICE_CAP))
  let left = total - out.reduce((a, b) => a + b, 0)
  while (left > 0) {
    const room = []
    for (let i = 0; i < n; i++) if (out[i] < ITEM_PRICE_CAP) room.push(i)
    if (!room.length) break
    const before = left
    for (const i of room) {
      if (left <= 0) break
      const give = Math.min(ITEM_PRICE_CAP - out[i], Math.ceil(left / room.length))
      out[i] += give
      left -= give
    }
    if (left === before) break
  }
  if (left > 0) {
    let mi = 0
    for (let i = 1; i < n; i++) if (out[i] > out[mi]) mi = i
    out[mi] += left
  }
  return out
}

function splitTotal(total, items) {
  const out = {}
  if (!items.length) return out
  if (items.length === 1) { out[items[0].id] = total; return out }
  const types = items.map(i => i.type)
  const unique = [...new Set(types)]
  const sig = [...types].sort().join(',')
  const noDup = types.length === unique.length
  let shares
  if (noDup && PACKAGE_SPLIT[sig]) {
    const pct = PACKAGE_SPLIT[sig]
    shares = items.map(i => total * (pct[i.type] || 0) / 100)
  } else {
    const w = items.map(i => TYPE_WEIGHT[i.type] || 20)
    const sum = w.reduce((a, b) => a + b, 0)
    shares = w.map(x => total * x / sum)
  }
  const rounded = shares.map(s => Math.round(s))
  const diff = total - rounded.reduce((a, b) => a + b, 0)
  if (diff !== 0) {
    let mi = 0
    rounded.forEach((v, idx) => { if (v > rounded[mi]) mi = idx })
    rounded[mi] += diff
  }
  const capped = applyPriceCap(rounded, total)
  items.forEach((i, idx) => { out[i.id] = capped[idx] })
  return out
}

function itemDescription(booking, item) {
  const spec = GARMENT_SPEC[item.type]
  if (item.type === 'tie') {
    const col = booking[`${item.id}_color`] || ''
    return { name: spec?.label || item.name, sub: col || 'Tie', detail: '' }
  }
  const fab = booking[`${item.id}_fabric`] || ''
  const shade = booking[`${item.id}_shade`] || ''
  const detail = booking[`${item.id}_detail`] || ''
  const parts = [fab, shade ? `Shade ${shade}` : ''].filter(Boolean)
  return { name: spec?.label || item.name, sub: parts.join(' · ') || 'Bespoke tailored', detail }
}

/**
 * Ek booking ka poora GST hisaab. Invoice aur monthly GST register DONO yahi
 * function use karte hain — isse register ke aankde customer ko diye gaye
 * invoice se hu-ba-hu milte hain (GST filing me yahi sabse zaroori hai).
 *
 * Prices GST-inclusive hain: taxable = price / (1 + rate/100).
 * Rate item ke share par: 2500 se upar 18%, warna 5% — isliye ek hi bill me
 * do rate ho sakte hain, aur rateRows unhe rate-wise alag karta hai.
 */
export function computeBookingGst(booking) {
  const items = booking.active_items || []
  const total = safeNum(booking.total_amount) || items.reduce((a, i) => a + safeNum(booking[`${i.id}_price`]), 0)
  const priceMap = splitTotal(total, items)
  const lineItems = items.map(item => {
    const price = priceMap[item.id] || 0
    const rate = gstRateForPrice(price)
    const taxable = price / (1 + rate / 100)
    return { item, desc: itemDescription(booking, item), price, rate, taxable, tax: price - taxable }
  })

  const net = lineItems.reduce((a, l) => a + l.price, 0)
  const taxableTotal = lineItems.reduce((a, l) => a + l.taxable, 0)
  const taxTotal = lineItems.reduce((a, l) => a + l.tax, 0)
  const roundedNet = Math.round(net)

  const buyerState = CAMPUS_STATE[booking.campus] || FIRM.state
  const isIntra = buyerState.toLowerCase().includes('chhattisgarh') || buyerState === FIRM.state

  const byRate = new Map()
  lineItems.forEach(l => {
    const b = byRate.get(l.rate) || { rate: l.rate, taxable: 0, tax: 0, gross: 0 }
    b.taxable += l.taxable; b.tax += l.tax; b.gross += l.price
    byRate.set(l.rate, b)
  })
  const rateRows = [...byRate.values()].sort((a, b) => a.rate - b.rate).map(b => ({
    ...b,
    cgst: isIntra ? b.tax / 2 : 0,
    sgst: isIntra ? b.tax / 2 : 0,
    igst: isIntra ? 0 : b.tax,
  }))

  return {
    items, lineItems, rateRows, total, net, taxableTotal, taxTotal, roundedNet,
    buyerState, isIntra,
    cgst: isIntra ? taxTotal / 2 : 0,
    sgst: isIntra ? taxTotal / 2 : 0,
    igst: isIntra ? 0 : taxTotal,
  }
}

export { FIRM }

// ── main: invoice ek naye window me kholta hai → user "Save as PDF" / print kare ──
export function generateInvoicePDF(booking) {
  const w = window.open('', '_blank', 'width=880,height=1000')
  if (!w) { alert('Popup blocked — please allow popups to open the invoice.'); return }

  const items = (booking.active_items || [])
  const meas = booking.measurements || {}
  const total = safeNum(booking.total_amount) || items.reduce((a, i) => a + safeNum(booking[`${i.id}_price`]), 0)
  const advance = safeNum(booking.advance_amount)
  const payNote = booking.payment_mode === 'both'
    ? `Cash ${fmtINR(safeNum(booking.advance_cash))} + Online ${fmtINR(safeNum(booking.advance_online))}`
    : (booking.payment_mode ? booking.payment_mode.charAt(0).toUpperCase() + booking.payment_mode.slice(1) : '')

  const gst = computeBookingGst(booking)
  const { lineItems, net, taxableTotal, taxTotal, roundedNet, buyerState, isIntra, cgst, sgst, igst } = gst
  const roundOff = roundedNet - net
  // Balance delivery pe collect hota hai (balance_paid) — use bhi ghatao, warna
  // poora paise dene ke baad bhi invoice "Balance Due" dikhata rehta hai.
  const balancePaid = safeNum(booking.balance_paid)
  const totalPaid = advance + balancePaid
  const balance = Math.max(0, roundedNet - totalPaid)
  const paidInFull = balance <= 0.01 && totalPaid >= roundedNet - 0.01

  const rateSet = [...new Set(lineItems.map(l => l.rate))]
  const gstLabel = rateSet.length === 1 ? `${rateSet[0]}%` : ''
  const halfLabel = rateSet.length === 1 ? `${rateSet[0] / 2}%` : ''

  const fmtDate = raw => raw ? new Date(raw).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : ''
  const dateStr = fmtDate(booking.order_date || booking.created_at) || fmtDate(new Date())
  const deliveryStr = fmtDate(booking.delivery_date)

  const itemRows = lineItems.map((l, idx) => `
    <tr>
      <td class="c">${idx + 1}</td>
      <td><div class="it-name">${esc(l.desc.name)}</div><div class="it-sub">${esc(l.desc.sub)}</div></td>
      <td class="c">${HSN_GARMENT}</td>
      <td class="c">1</td>
      <td class="r">${fmtINR(l.price)}</td>
      <td class="r">${fmtINR(l.taxable)}</td>
      <td class="c">${l.rate}%</td>
      <td class="r">${fmtINR(l.price)}</td>
    </tr>`).join('')

  const measBlocks = items.map(item => {
    const spec = GARMENT_SPEC[item.type]
    if (!spec || item.type === 'tie') return ''
    const keys = [spec.length, ...spec.fields].filter(Boolean)
    const chips = keys.map(key => {
      const add = ALLOWANCE[item.type]?.[key] || 0
      const base = safeNum(meas[key])
      if (!base) return ''
      const shown = base + add
      const lbl = FIELD_LABEL[key] || key
      return `<div class="m-chip"><span>${lbl}</span><b>${fmtInch(shown)}</b></div>`
    }).filter(Boolean).join('')
    if (!chips) return ''
    const desc = itemDescription(booking, item)
    let qrHtml = ''
    if (booking[`${item.id}_ref_image`] && booking.id) {
      const url = `${REF_BASE}/ref-image/${booking.id}/${item.id}`
      qrHtml = `<div class="m-qr"><img src="${qrUrl(url, 150)}" alt="Reference"/><span>Scan: Design</span></div>`
    }
    return `
      <div class="m-block">
        <div class="m-head"><b>${esc(spec.label)}</b><span>${esc(desc.sub)}</span></div>
        <div class="m-body">
          <div class="m-grid">${chips}</div>
          ${qrHtml}
        </div>
        ${desc.detail ? `<div class="m-detail"><span>Style:</span> ${esc(desc.detail)}</div>` : ''}
      </div>`
  })
  const measSection = measBlocks.filter(Boolean).join('')
  const siteQr = qrUrl('https://www.maviinci.in/', 220)
  const isCancelled = booking.status === 'cancelled'

  w.document.open()
  w.document.write(`
<html><head><meta charset="utf-8"/><title>${esc(booking.invoice_no || 'Invoice')}</title>
<style>
* { box-sizing: border-box; }
body { font-family: 'Segoe UI', Arial, sans-serif; color: #1a1410; margin: 0; padding: 10px; background: #f4f1eb; font-size: 10px; }
.invoice { position: relative; width: 190mm; margin: 0 auto; background: #fff; border: 1px solid #e2d7c6; border-radius: 10px; overflow: hidden; }
.iv-cancel-wm { position: absolute; top: 42%; left: 50%; transform: translate(-50%,-50%) rotate(-24deg); font-size: 96px; font-weight: 900; letter-spacing: .1em; color: rgba(211,0,0,0.14); border: 8px solid rgba(211,0,0,0.14); border-radius: 14px; padding: 6px 34px; pointer-events: none; z-index: 5; white-space: nowrap; }
.iv-cancel-stamp { display: inline-block; margin-top: 4px; padding: 3px 12px; border: 2px solid #d30000; color: #d30000; font-size: 13px; font-weight: 900; letter-spacing: .14em; border-radius: 6px; }
.iv-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; padding: 10px 16px 8px; border-bottom: 2px solid #17110a; }
.iv-brand img.logo { height: 34px; width: auto; display: block; }
.iv-firm { margin-top: 6px; font-size: 9px; line-height: 1.4; color: #4a3f33; }
.iv-firm .legal { font-size: 12px; font-weight: 800; color: #17110a; letter-spacing: .04em; }
.iv-firm .gstin { margin-top: 2px; font-weight: 700; color: #9d7130; }
.iv-title { text-align: right; }
.iv-title h1 { margin: 0; font-size: 17px; letter-spacing: .14em; color: #9d7130; text-transform: uppercase; }
.iv-meta { margin-top: 6px; font-size: 9.5px; color: #4a3f33; line-height: 1.5; }
.iv-meta b { color: #17110a; }
.iv-parties { display: grid; grid-template-columns: 1fr 1fr; border-bottom: 1px solid #eadfce; }
.iv-party { padding: 8px 16px; font-size: 9.5px; line-height: 1.45; color: #4a3f33; }
.iv-party:first-child { border-right: 1px solid #eadfce; }
.iv-party .lbl { font-size: 8.5px; font-weight: 800; letter-spacing: .12em; text-transform: uppercase; color: #9d7130; margin-bottom: 3px; }
.iv-party .pname { font-size: 12px; font-weight: 800; color: #17110a; margin-bottom: 1px; }
table.items { width: 100%; border-collapse: collapse; font-size: 9.5px; }
table.items thead th { background: #17110a; color: #f3e7cf; font-weight: 700; text-transform: uppercase; letter-spacing: .03em; font-size: 8.5px; padding: 6px 7px; text-align: left; }
table.items tbody td { padding: 5px 7px; border-bottom: 1px solid #efe7d8; vertical-align: top; }
table.items tbody tr:nth-child(even) { background: #faf6ef; }
.it-name { font-weight: 700; color: #221a10; }
.it-sub { font-size: 8.5px; color: #8a7a64; margin-top: 1px; }
td.c, th.c { text-align: center; } td.r, th.r { text-align: right; }
.iv-bottom { display: grid; grid-template-columns: 1.1fr 0.9fr; border-top: 2px solid #17110a; }
.iv-words { padding: 8px 16px; font-size: 9.5px; color: #4a3f33; border-right: 1px solid #eadfce; }
.iv-words .lbl { font-size: 8.5px; font-weight: 800; letter-spacing: .1em; text-transform: uppercase; color: #9d7130; margin-bottom: 3px; }
.iv-words .amt { font-weight: 800; color: #17110a; font-size: 11px; line-height: 1.4; }
.iv-totals { padding: 7px 16px; }
.iv-totals .row { display: flex; justify-content: space-between; font-size: 10px; padding: 2px 0; color: #4a3f33; }
.iv-totals .row b { color: #17110a; }
.iv-net { display: flex; justify-content: space-between; align-items: center; margin-top: 4px; padding: 7px 12px; background: #17110a; color: #fff; border-radius: 8px; }
.iv-net .nlbl { font-size: 9.5px; letter-spacing: .08em; text-transform: uppercase; color: #d8b36a; }
.iv-net .nval { font-size: 15px; font-weight: 800; }
.iv-due { display: flex; justify-content: space-between; color: #9d7130; font-weight: 800; font-size: 10.5px; margin-top: 4px; padding: 0 2px; }
.iv-due--paid { color: #0F7B3E; }
.iv-paid-stamp { margin-top: 7px; text-align: center; font-size: 13px; font-weight: 900; letter-spacing: .18em; color: #0F7B3E; border: 2px solid #0F7B3E; border-radius: 6px; padding: 5px 0; text-transform: uppercase; }
.m-section { padding: 6px 16px 2px; border-top: 1px solid #eadfce; }
.m-section > .lbl { font-size: 9px; font-weight: 800; letter-spacing: .1em; text-transform: uppercase; color: #9d7130; margin-bottom: 4px; }
.m-block { border: 1px solid #ece3d3; border-radius: 7px; margin-bottom: 4px; overflow: hidden; }
.m-head { display: flex; justify-content: space-between; align-items: baseline; gap: 8px; background: #faf6ef; padding: 3px 9px; border-bottom: 1px solid #ece3d3; }
.m-head b { font-size: 10.5px; color: #17110a; } .m-head span { font-size: 8px; color: #8a7a64; }
.m-body { display: flex; gap: 8px; padding: 4px 9px; align-items: center; }
.m-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(62px, 1fr)); gap: 4px; flex: 1; }
.m-chip { display: flex; flex-direction: column; gap: 0; background: #f7f2ea; border: 1px solid #ece3d3; border-radius: 5px; padding: 2px 6px; }
.m-chip span { font-size: 7px; color: #8a7a64; text-transform: uppercase; letter-spacing: .03em; }
.m-chip b { font-size: 11.5px; color: #17110a; }
.m-qr { flex-shrink: 0; text-align: center; }
.m-qr img { width: 46px; height: 46px; border: 2px solid #d8b36a; border-radius: 5px; display: block; }
.m-qr span { font-size: 6.5px; color: #9d7130; font-weight: 700; letter-spacing: .04em; margin-top: 1px; display: block; }
.m-detail { padding: 3px 9px 5px; font-size: 8.5px; color: #6f604d; border-top: 1px dashed #ece3d3; }
.m-detail span { font-weight: 800; color: #9d7130; text-transform: uppercase; font-size: 7.5px; letter-spacing: .06em; }
.iv-foot { display: grid; grid-template-columns: 1fr 1fr; border-top: 1px solid #eadfce; }
.iv-foot > div { padding: 6px 16px; font-size: 8.5px; line-height: 1.35; color: #4a3f33; }
.iv-foot .note { border-right: 1px solid #eadfce; }
.iv-foot .lbl { font-size: 8px; font-weight: 800; letter-spacing: .1em; text-transform: uppercase; color: #9d7130; margin-bottom: 2px; }
.iv-sign { text-align: right; display: flex; flex-direction: column; align-items: flex-end; justify-content: space-between; }
.iv-sign .for { font-weight: 700; color: #17110a; }
.iv-sign img.sign { height: 30px; width: auto; margin: 1px 0; object-fit: contain; }
.iv-sign .line { border-top: 1px solid #b9a987; padding-top: 2px; min-width: 140px; font-size: 8.5px; }
.iv-sign .founder { font-size: 8px; color: #8a7a64; margin-top: 1px; }
.iv-offer { display: flex; align-items: center; justify-content: space-between; gap: 14px; background: #17110a; padding: 8px 16px; }
.iv-offer-eyebrow { font-size: 7.5px; font-weight: 800; letter-spacing: .16em; text-transform: uppercase; color: #d8b36a; margin-bottom: 3px; }
.iv-offer-headline { font-size: 11.5px; font-weight: 800; color: #fff; line-height: 1.2; margin-bottom: 4px; }
.iv-offer-points { list-style: none; margin: 0; padding: 0; }
.iv-offer-points li { font-size: 8.5px; color: #bfb09a; line-height: 1.45; padding-left: 11px; position: relative; }
.iv-offer-points li::before { content: '✦'; position: absolute; left: 0; color: #d8b36a; font-size: 6.5px; top: 3px; }
.iv-offer-qr { flex-shrink: 0; text-align: center; }
.iv-offer-qr img { width: 58px; height: 58px; border-radius: 7px; border: 2px solid #d8b36a; display: block; }
.iv-offer-qr .qr-label { margin-top: 2px; font-size: 7.5px; color: #d8b36a; font-weight: 700; letter-spacing: .08em; }
.iv-terms { padding: 5px 16px 8px; font-size: 7.5px; color: #8a7a64; line-height: 1.35; border-top: 1px solid #eadfce; }
.iv-terms b { color: #4a3f33; }
@media print {
  body { background: #fff; padding: 0; font-size: 10px; }
  .invoice { border: none; border-radius: 0; width: 100%; }
  .m-block, .iv-offer, .iv-foot, .iv-terms, .iv-bottom { page-break-inside: avoid; }
  @page { size: A4; margin: 6mm; }
}
</style></head>
<body>
  <div class="invoice">
    ${isCancelled ? '<div class="iv-cancel-wm">CANCELLED</div>' : ''}
    <div class="iv-head">
      <div>
        <div class="iv-brand"><img class="logo" src="${abs(logoUrl)}" alt="MAVIINCI"/></div>
        <div class="iv-firm">
          <div class="legal">${FIRM.legalName}</div>
          <div>${FIRM.address}, ${FIRM.district}</div>
          <div>${FIRM.founder} (Founder): ${FIRM.founderMobile}</div>
          <div>${FIRM.coFounder} (Co-Founder): ${FIRM.coFounderMobile}</div>
          <div>${FIRM.website} &nbsp;|&nbsp; ${FIRM.email}</div>
          <div class="gstin">GSTIN: ${FIRM.gstin} &nbsp; State: ${FIRM.state} (${FIRM.stateCode})</div>
        </div>
      </div>
      <div class="iv-title">
        <h1>Tax Invoice</h1>
        ${isCancelled ? '<div class="iv-cancel-stamp">CANCELLED</div>' : ''}
        <div class="iv-meta">
          <div><b>Invoice No:</b> ${esc(booking.invoice_no || '—')}</div>
          <div><b>Order Date:</b> ${dateStr}</div>
          ${deliveryStr ? `<div><b>Delivery Date:</b> ${deliveryStr}</div>` : ''}
          <div><b>Place of Supply:</b> ${esc(buyerState)}</div>
        </div>
      </div>
    </div>

    <div class="iv-parties">
      <div class="iv-party">
        <div class="lbl">Bill To</div>
        <div class="pname">${esc(booking.customer_name || 'Customer')}</div>
        <div>Mobile: ${esc(booking.customer_mobile || '—')}</div>
        <div>${esc(booking.campus || '')}</div>
      </div>
      <div class="iv-party">
        <div class="lbl">Order Info</div>
        <div>Booked By: ${esc(booking.created_by_name || '—')}</div>
        <div>Status: ${esc(booking.status || 'booked')}</div>
        ${deliveryStr ? `<div>Delivery: <b>${deliveryStr}</b></div>` : ''}
      </div>
    </div>

    <table class="items">
      <thead><tr>
        <th class="c">#</th><th>Description of Goods</th><th class="c">HSN</th>
        <th class="c">Qty</th><th class="r">Rate</th><th class="r">Taxable</th>
        <th class="c">GST%</th><th class="r">Amount</th>
      </tr></thead>
      <tbody>${itemRows || '<tr><td colspan="8" class="c">No items</td></tr>'}</tbody>
    </table>

    <div class="iv-bottom">
      <div class="iv-words">
        <div class="lbl">Amount Chargeable (in words)</div>
        <div class="amt">${numberToWordsIN(roundedNet)}</div>
      </div>
      <div class="iv-totals">
        <div class="row"><span>Taxable Value</span><b>${fmtINR(taxableTotal)}</b></div>
        ${isIntra
          ? `<div class="row"><span>CGST${halfLabel ? ' @ ' + halfLabel : ''}</span><span>${fmtINR(cgst)}</span></div>
             <div class="row"><span>SGST${halfLabel ? ' @ ' + halfLabel : ''}</span><span>${fmtINR(sgst)}</span></div>`
          : `<div class="row"><span>IGST${gstLabel ? ' @ ' + gstLabel : ''}</span><span>${fmtINR(igst)}</span></div>`}
        ${Math.abs(roundOff) >= 0.01 ? `<div class="row"><span>Round Off</span><span>${roundOff >= 0 ? '+' : '-'} ${fmtINR(Math.abs(roundOff))}</span></div>` : ''}
        <div class="iv-net"><span class="nlbl">Total</span><span class="nval">${fmtINR(roundedNet)}</span></div>
        ${paidInFull
          // Poora paid (delivery ke baad) => saaf paid bill, advance/balance ka
          // hisaab nahi — bas PAID IN FULL.
          ? `<div class="iv-paid-stamp">PAID IN FULL</div>`
          // Abhi paisa baaki => advance + balance ka breakdown.
          : `${advance > 0 ? `<div class="iv-due"><span>Advance Paid${payNote ? ` (${payNote})` : ''}</span><span>- ${fmtINR(advance)}</span></div>` : ''}
             ${balancePaid > 0 ? `<div class="iv-due"><span>Balance Paid</span><span>- ${fmtINR(balancePaid)}</span></div>` : ''}
             ${(advance > 0 || balancePaid > 0) ? `<div class="iv-due"><span>Balance Due</span><span>${fmtINR(balance)}</span></div>` : ''}`}
      </div>
    </div>

    ${measSection ? `<div class="m-section"><div class="lbl">Measurement Details (inches)</div>${measSection}</div>` : ''}

    <div class="iv-foot">
      <div class="note">
        <div class="lbl">Notes</div>
        <div>Thank you for choosing ${FIRM.brand}. Each garment is bespoke-crafted to your measurements.</div>
        <div>Support: ${FIRM.founderMobile} &nbsp;|&nbsp; ${FIRM.coFounderMobile}</div>
      </div>
      <div class="iv-sign">
        <div class="for">For ${FIRM.legalName}</div>
        <img class="sign" src="${abs(signUrl)}" alt=""/>
        <div class="line">Authorised Signatory</div>
        <div class="founder">${FIRM.founder}, Founder</div>
      </div>
    </div>

    <div class="iv-offer">
      <div>
        <div class="iv-offer-eyebrow">Where Fashion Meets The Future</div>
        <div class="iv-offer-headline">MAVIINCI — India's First Real-Time Custom Tailoring Platform</div>
        <ul class="iv-offer-points">
          <li>Design your outfit live — fabric, lapel, lining &amp; fit, exactly your way</li>
          <li>AI photo-scan fit &amp; premium fabrics — Italian wools, Egyptian cottons, Indian silks</li>
          <li>Wedding, formal &amp; occasion bespoke — crafted and delivered to your campus</li>
        </ul>
      </div>
      <div class="iv-offer-qr">
        <img src="${siteQr}" alt="Visit MAVIINCI"/>
        <div class="qr-label">WWW.MAVIINCI.IN</div>
      </div>
    </div>

    <div class="iv-terms">
      <b>Terms &amp; Conditions:</b> Goods once sold are bespoke-made and non-returnable. Prices are inclusive of GST. This is a computer-generated invoice. Subject to Durg (Chhattisgarh) jurisdiction.
    </div>
  </div>
  <script>
    (function () {
      function go() { window.focus(); window.print(); }
      var imgs = Array.prototype.slice.call(document.images);
      var pending = imgs.filter(function (i) { return !i.complete; }).length;
      if (pending === 0) { window.onload = go; return; }
      var done = 0;
      imgs.forEach(function (i) {
        if (i.complete) { if (++done === pending) {} return; }
        i.addEventListener('load', function () { if (--pending === 0) go(); });
        i.addEventListener('error', function () { if (--pending === 0) go(); });
      });
      if (pending === 0) go();
    })();
  <\/script>
</body></html>`)
  w.document.close()
}

// ── Tailor measurement sheet (per fabric + per garment TYPE) ─────────────────
// Coat ka tailor alag, pant ka alag, shirt ka alag — isliye har sheet sirf EK
// garment type ki hoti hai. pieces: [{ booking, item }] (sabhi same type ke,
// same fabric+shade). Har piece ka customer label + uske measurement fields
// (cutting allowance already added).
export function generateFabricTailorSheet(fabricName, shade, garmentType, pieces) {
  const w = window.open('', '_blank', 'width=880,height=1000')
  if (!w) { alert('Popup blocked — please allow popups to open the sheet.'); return }

  const spec = GARMENT_SPEC[garmentType] || { label: garmentType, length: null, fields: [] }
  const keys = [spec.length, ...spec.fields].filter(Boolean)

  const normKey = (s) => String(s || '').trim().toLowerCase()

  // Shirting fabric lagbhag har order me ek hi hota hai (Raymond Crystal · White),
  // to us se grouping bekaar hai. Kaam suit (coat/pant) fabric ke hisaab se chalta
  // hai — isliye shirt sheet me pieces customer ke apne coat/pant fabric wise
  // line-se lagte hain, har suit fabric pe divider ke saath.
  const isShirt = garmentType === 'shirt'
  const suitFabOf = (p) => {
    const b = p.booking || {}
    const items = b.active_items || []
    const pick = items.find((i) => i.type === 'coat') || items.find((i) => i.type === 'pant')
    if (!pick) return { fab: '', shd: '' }
    return { fab: b[`${pick.id}_fabric`] || '', shd: b[`${pick.id}_shade`] || '' }
  }
  const suitKeyOf = (p) => { const { fab, shd } = suitFabOf(p); return `${normKey(fab)}||${normKey(shd)}` }
  const suitLabelOf = (p) => {
    const { fab, shd } = suitFabOf(p)
    return `${fab || 'No suit fabric'}${shd ? ` · Shade ${shd}` : ''}`
  }

  let list = pieces || []
  if (isShirt) {
    list = [...list].sort((a, b) => {
      const ka = suitKeyOf(a), kb = suitKeyOf(b)
      if (ka !== kb) return ka.localeCompare(kb)
      return String(a.booking?.invoice_no || '').localeCompare(
        String(b.booking?.invoice_no || ''), undefined, { numeric: true })
    })
  }

  // Ek naap card: bada Bill No, customer, fabric, QR (agar ref photo/detail ho),
  // aur measurement chips. 6 card per A4 page (2×3 grid) — naap bade dikhein.
  const cardHtml = (p) => {
    const meas = p.booking.measurements || {}
    const chips = keys.map(key => {
      const add = ALLOWANCE[garmentType]?.[key] || 0
      const base = safeNum(meas[key])
      if (!base) return ''
      const lbl = FIELD_LABEL[key] || key
      return `<div class="m-chip"><span>${esc(lbl)}</span><b>${fmtInch(base + add)}</b></div>`
    }).filter(Boolean).join('')
    const desc = itemDescription(p.booking, p.item)
    const isFemale = String(p.booking.gender || '').toLowerCase().startsWith('f')
    let qrHtml = ''
    if (p.booking[`${p.item.id}_ref_image`] && p.booking.id) {
      const url = `${REF_BASE}/ref-image/${p.booking.id}/${p.item.id}`
      qrHtml = `<div class="pc-qr"><img src="${qrUrl(url, 130)}" alt="Design"/><span>Scan design</span></div>`
    }
    return `<div class="pc${isFemale ? ' pc--female' : ''}">
      <div class="pc-top">
        <div class="pc-bill">
          <span class="pc-bill-lbl">Bill No</span>
          <span class="pc-bill-no">${esc(p.booking.invoice_no || '—')}</span>
          <span class="pc-cust">${esc(p.booking.customer_name || '')}</span>
        </div>
        <div class="pc-right">
          ${isFemale ? '<span class="pc-female">Female</span>' : ''}
          ${qrHtml}
        </div>
      </div>
      <div class="pc-fab">${(() => {
        // fabricName null => mixed-fabric sheet: har piece apna fabric+shade dikhaye
        const pFab = fabricName || p.booking[`${p.item.id}_fabric`] || 'Fabric'
        const pShade = fabricName ? shade : (p.booking[`${p.item.id}_shade`] || '')
        return `${esc(pFab)}${pShade ? ` · Shade ${esc(pShade)}` : ''}`
      })()}</div>
      ${isShirt ? `<div class="pc-suit"><span>Suit:</span> ${esc(suitLabelOf(p))}</div>` : ''}
      ${desc.detail ? `<div class="pc-style"><span>Style:</span> ${esc(desc.detail)}</div>` : ''}
      <div class="m-grid">${chips || '<i class="m-none">No measurements recorded</i>'}</div>
    </div>`
  }

  // Mixed-fabric sheet (fabricName null, e.g. "All remaining") — pieces already
  // arrive grouped fabric-wise (see remainingByFabric in campus_orders.js), so a
  // fabric change is always a group boundary. Ek clear divider bar daal do taaki
  // tailor ko turant pata chale "yahan se naya fabric shuru".
  const pieceFabKey = (p) => `${normKey(p.booking[`${p.item.id}_fabric`])}||${normKey(p.booking[`${p.item.id}_shade`])}`

  // Consecutive pieces ko groups me todo (shirt => suit fabric, mixed sheet => piece fabric)
  const useDividers = isShirt || !fabricName
  const groupKeyOf = (p) => (isShirt ? suitKeyOf(p) : pieceFabKey(p))
  const groups = []
  list.forEach((p) => {
    const key = useDividers ? groupKeyOf(p) : '__all'
    const last = groups[groups.length - 1]
    if (!last || last.key !== key) groups.push({ key, pieces: [p] })
    else last.pieces.push(p)
  })

  const dividerHtml = (g, gi) => {
    if (!useDividers) return ''
    const p = g.pieces[0]
    if (isShirt) {
      // Shirt: suit (coat/pant) fabric wise sections — pehle group pe bhi label,
      // kyunki page header me shirting fabric likha hota hai, suit fabric nahi.
      const n = g.pieces.length
      return `<div class="fab-divider"><span>${esc(suitLabelOf(p))} — ${n} shirt${n === 1 ? '' : 's'}</span></div>`
    }
    if (gi === 0) return '' // mixed sheet: pehla group bina label (purana behaviour)
    const fabLabel = p.booking[`${p.item.id}_fabric`] || 'Fabric'
    const shadeLabel = p.booking[`${p.item.id}_shade`] || ''
    return `<div class="fab-divider"><span>${esc(fabLabel)}${shadeLabel ? ` · Shade ${esc(shadeLabel)}` : ''}</span></div>`
  }

  // A4 page = 2 card/row. Divider poori width leta hai to har naya group nayi row
  // se shuru hota hai — fixed "6 pieces per page" chunking is wajah se page
  // overflow kar deti thi. Ab height ke hisaab se pack karo (mm me):
  //   297 page − 18 padding − 15 page-head ≈ 264 grid ke liye
  const PAGE_H = 264   // grid ke liye available height
  const ROW_H = 79     // card row (74) + gap (5)
  const DIV_H = 12     // divider bar + margin
  const pages = []
  let cur = { h: 0, html: '' }
  const flushPage = () => { if (cur.html) pages.push(cur.html); cur = { h: 0, html: '' } }
  groups.forEach((g, gi) => {
    const div = dividerHtml(g, gi)
    for (let i = 0; i < g.pieces.length; i += 2) {
      const needDiv = i === 0 && div ? DIV_H : 0
      if (cur.h > 0 && cur.h + needDiv + ROW_H > PAGE_H) flushPage()
      if (needDiv) cur.html += div
      cur.html += g.pieces.slice(i, i + 2).map(cardHtml).join('')
      cur.h += needDiv + ROW_H
    }
  })
  flushPage()
  const dateStr = new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
  const pagesHtml = pages.length ? pages.map((pg, pi) => `
    <div class="page">
      <div class="page-head">
        <div><span class="ph-type">${esc(spec.label)}</span> <span class="ph-fab">${esc(fabricName || 'All Fabrics (remaining)')}${fabricName && shade ? ` · Shade ${esc(shade)}` : ''}</span>${isShirt ? '<span class="ph-note">grouped by suit fabric</span>' : ''}</div>
        <div class="ph-meta">${esc(FIRM.brand)} · ${list.length} ${esc(spec.label.toLowerCase())}${list.length === 1 ? '' : 's'} · ${dateStr} · Page ${pi + 1}/${pages.length}</div>
      </div>
      <div class="grid8">${pg}</div>
    </div>`).join('')
    : '<div class="page"><div class="grid8">No garments found.</div></div>'

  w.document.open()
  w.document.write(`
<html><head><meta charset="utf-8"/><title>${esc(spec.label)} Sheet — ${esc(fabricName || 'Fabric')}</title>
<style>
* { box-sizing: border-box; }
html, body, .pc, .pc--female, .m-chip, .pc-female { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
body { font-family: 'Segoe UI', Arial, sans-serif; color: #1a1410; margin: 0; padding: 0; background: #e9e4da; }
.page { background: #fff; width: 210mm; min-height: 297mm; margin: 0 auto 8mm; padding: 9mm; }
.page-head { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; border-bottom: 2px solid #17110a; padding-bottom: 5px; margin-bottom: 6mm; }
.ph-type { font-size: 19px; font-weight: 800; color: #9d7130; text-transform: uppercase; letter-spacing: .05em; }
.ph-fab { font-size: 13px; font-weight: 700; color: #17110a; }
.ph-meta { font-size: 9.5px; color: #6b5b45; }
.ph-note { font-size: 9px; font-weight: 700; color: #9d7130; text-transform: uppercase; letter-spacing: .06em; margin-left: 8px; }
.grid8 { display: grid; grid-template-columns: 1fr 1fr; gap: 5mm; }
.pc { border: 1.5px solid #d8cbb0; border-radius: 9px; padding: 9px 11px; min-height: 74mm; page-break-inside: avoid; display: flex; flex-direction: column; }
.pc-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 8px; }
.pc-bill { display: flex; flex-direction: column; min-width: 0; }
.pc-bill-lbl { font-size: 8px; font-weight: 800; letter-spacing: .14em; text-transform: uppercase; color: #9d7130; }
.pc-bill-no { font-size: 28px; font-weight: 900; color: #17110a; line-height: 1; letter-spacing: .01em; }
.pc-cust { font-size: 11px; font-weight: 700; color: #4a3f33; margin-top: 3px; text-transform: capitalize; }
.pc-right { display: flex; flex-direction: column; align-items: flex-end; gap: 5px; flex-shrink: 0; }
.pc-qr { text-align: center; flex-shrink: 0; }
.pc-qr img { width: 48px; height: 48px; display: block; background: #fff; padding: 2px; border-radius: 4px; }
.pc-qr span { font-size: 6.5px; color: #8a7a64; letter-spacing: .02em; }
.pc-female { display: inline-block; padding: 2px 10px; border-radius: 999px; background: #e26aa0; color: #fff; font-size: 9px; font-weight: 800; letter-spacing: .1em; text-transform: uppercase; white-space: nowrap; }
/* Female piece — dark card, light text (turant pehchane) */
.pc--female { background: #17110a; border-color: #17110a; color: #f3e7cf; }
.pc--female .pc-bill-lbl { color: #d7a869; }
.pc--female .pc-bill-no { color: #ffffff; }
.pc--female .pc-cust { color: #e9dcc4; }
.pc--female .pc-fab { color: #e7c185; }
.pc--female .pc-style { color: #cdbf9f; }
.pc--female .pc-style span { color: #e7c185; }
.pc--female .m-chip { background: rgba(255, 255, 255, 0.07); border-color: rgba(255, 255, 255, 0.22); }
.pc--female .m-chip span { color: #bcae90; }
.pc--female .m-chip b { color: #ffffff; }
.pc--female .pc-qr span { color: #bcae90; }
.pc-fab { font-size: 11.5px; font-weight: 700; color: #6b4f1d; margin-top: 6px; }
.pc-style { font-size: 9px; color: #6b5b45; margin-top: 2px; }
.pc-style span { font-weight: 700; color: #9d7130; }
.pc-suit { font-size: 10.5px; font-weight: 700; color: #17110a; margin-top: 3px; }
.pc-suit span { font-weight: 800; color: #9d7130; text-transform: uppercase; letter-spacing: .04em; font-size: 9px; }
.pc--female .pc-suit { color: #f3e7cf; }
.pc--female .pc-suit span { color: #e7c185; }
.m-grid { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 9px; }
.m-chip { display: flex; flex-direction: column; align-items: center; min-width: 60px; padding: 6px 9px; border: 1px solid #e6dccb; border-radius: 7px; background: #faf6ef; }
.m-chip span { font-size: 10px; color: #6b5b45; text-transform: uppercase; letter-spacing: .03em; font-weight: 700; }
.m-chip b { font-size: 25px; color: #17110a; margin-top: 2px; line-height: 1; }
.m-none { color: #b04a3a; font-style: italic; font-size: 11px; }
.fab-divider { grid-column: 1 / -1; display: flex; align-items: center; gap: 8px; margin: 4px 0 -1px; page-break-after: avoid; }
.fab-divider::before { content: ''; flex: 0 0 4px; align-self: stretch; background: #9d7130; border-radius: 2px; }
.fab-divider span { font-size: 12px; font-weight: 800; color: #17110a; text-transform: uppercase; letter-spacing: .04em; background: #f2e6cf; border: 1px solid #e4d4bd; border-radius: 6px; padding: 5px 12px; }
@media print {
  body { background: #fff; }
  .page { width: auto; min-height: auto; margin: 0; padding: 0; }
  .page + .page { page-break-before: always; }
  .pc { page-break-inside: avoid; }
  @page { size: A4; margin: 9mm; }
}
</style></head>
<body>
  ${pagesHtml}
  <script>
    (function () {
      function go() { window.focus(); window.print(); }
      var imgs = Array.prototype.slice.call(document.images);
      var pending = imgs.filter(function (i) { return !i.complete; }).length;
      if (pending === 0) { window.onload = go; return; }
      imgs.forEach(function (i) {
        if (i.complete) return;
        i.addEventListener('load', function () { if (--pending === 0) go(); });
        i.addEventListener('error', function () { if (--pending === 0) go(); });
      });
    })();
  <\/script>
</body></html>`)
  w.document.close()
}

export { GARMENT_SPEC, CAMPUS_STATE }
